import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4f3eaf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "register-test-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_navigation = _resolveComponent("base-navigation")!
  const _component_test_instructions_StepOne = _resolveComponent("test-instructions-StepOne")!
  const _component_test_instructions_StepTwo = _resolveComponent("test-instructions-StepTwo")!
  const _component_test_instructions_StepThree = _resolveComponent("test-instructions-StepThree")!
  const _component_result_test = _resolveComponent("result-test")!
  const _component_result_picture = _resolveComponent("result-picture")!
  const _component_check_symptoms = _resolveComponent("check-symptoms")!
  const _component_basic_personal_data = _resolveComponent("basic-personal-data")!
  const _component_personal_data = _resolveComponent("personal-data")!
  const _component_base_footer = _resolveComponent("base-footer")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_navigation, { selectedStep: _ctx.getActiveStep }, null, 8, ["selectedStep"]),
      _withDirectives(_createVNode(_component_test_instructions_StepOne, {
        ref: "step-1",
        active: _ctx.activeStep == 1,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 1]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepTwo, {
        ref: "step-2",
        active: _ctx.activeStep == 2,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 2]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepThree, {
        ref: "step-3",
        active: _ctx.activeStep == 3,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 3]
      ]),
      _withDirectives(_createVNode(_component_result_test, {
        ref: "step-4",
        active: _ctx.activeStep == 4,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 4]
      ]),
      _withDirectives(_createVNode(_component_result_picture, {
        ref: "step-5",
        active: _ctx.activeStep == 5,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 5]
      ]),
      _withDirectives(_createVNode(_component_check_symptoms, {
        ref: "step-6",
        active: _ctx.activeStep == 6,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 6]
      ]),
      _withDirectives(_createVNode(_component_basic_personal_data, {
        ref: "step-7",
        active: _ctx.activeStep == 7,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 7]
      ]),
      _withDirectives(_createVNode(_component_personal_data, {
        ref: "step-8",
        active: _ctx.activeStep == 8,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 8]
      ]),
      (!_ctx.hideFooter)
        ? (_openBlock(), _createBlock(_component_base_footer, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.Loader)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, {
          key: 0,
          class: "loader"
        }))
      : _createCommentVNode("", true)
  ], 64))
}